import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from '@Root/slices'
import { fetchChangeIsAllowNotice, fetchOwnerArticle, fetchConfirmArticle } from '@Root/slices/ownerArticle/ownerArticle'

export default function useOwnerArticle() {
  const dispatch = useDispatch()
  const ownerArticle = useSelector((state: RootState) => state.ownerArticle)

  const loadOwnerArticle = useCallback(
    (articleNo: string) => {
      dispatch(fetchOwnerArticle(articleNo))
    },
    [dispatch],
  )

  const updateIsAllowNotice = useCallback(
    (param: { encryptedArticleNo: string; isAllowNotice: boolean }) => {
      dispatch(fetchChangeIsAllowNotice(param))
    },
    [dispatch],
  )

  const updateIsArticleConfirm = useCallback(
    (encryptedArticleNo: string) => {
      dispatch(fetchConfirmArticle(encryptedArticleNo))
    },
    [dispatch],
  )

  return {
    ownerArticle,
    loadOwnerArticle,
    updateIsAllowNotice,
    updateIsArticleConfirm,
  }
}
